import { CollapsibleContent } from './CollapsibleContent';
import { CollapsibleRoot } from './CollapsibleRoot';
import { CollapsibleTrigger } from './CollapsibleTrigger';

const Collapsible = Object.assign(CollapsibleRoot, {
  Content: CollapsibleContent,
  Trigger: CollapsibleTrigger,
}) as typeof CollapsibleRoot & {
  Content: typeof CollapsibleContent;
  Trigger: typeof CollapsibleTrigger;
};

export { Collapsible };
export type { CollapsibleProps, Placement } from './types';
